// formValidation.js

export const validateForm = (formData, errors, incompleteItems) => {
    let newErrors = { ...errors };
    let newIncompleteItems = [...incompleteItems];

    // Validación de datos del responsable
    if (!formData.responsibleName.trim() || !formData.responsiblePosition.trim()) {
        newErrors.responsibleInfo = 'El nombre y el cargo del responsable son obligatorios.';
    } else {
        delete newErrors.responsibleInfo;
    }

    // Validación de ítems de compra
    newIncompleteItems = formData.shoppingItems
        .map(item => {
            const allFieldsEmpty =
                item.detail.trim() === '' &&
                item.quantity.trim() === '' &&
                (item.unitValue === 0 || item.unitValue === null) &&
                item.totalValue === 0;

            if (allFieldsEmpty) return null;

            const missingFields = [];
            if (item.detail.trim() === '') missingFields.push('detail');
            if (item.quantity.trim() === '') missingFields.push('quantity');
            if (item.unitValue === 0 || item.unitValue === null) missingFields.push('unitValue');

            return missingFields.length > 0 ? { id: item.id, missingFields } : null;
        })
        .filter(Boolean);

    // Verificar si hay al menos un ítem completo
    const hasCompleteItem = formData.shoppingItems.some(item =>
        item.detail.trim() !== '' &&
        item.quantity.trim() !== '' &&
        item.unitValue > 0 &&
        item.unitValue !== null &&
        item.totalValue > 0
    );

    if (!hasCompleteItem) {
        newErrors.shoppingItems = 'Debe ingresar al menos un ítem de compra completo.';
    } else if (newIncompleteItems.length > 0) {
        newErrors.shoppingItems = 'Complete o elimine los items de compra incompletos.';
    } else {
        delete newErrors.shoppingItems;
    }

    // Validación de documentos oficiales
    if (formData.attachments.officialDocs.length === 0) {
        newErrors.officialDocs = 'Debe adjuntar al menos un documento oficial.';
    } else {
        delete newErrors.officialDocs;
    }

    return {
        isValid: Object.keys(newErrors).length === 0,
        newErrors,
        newIncompleteItems
    };
};